var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDomesticA(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8 5H30.8H28.8H9.20003C4.83951 8.35204 2.00003 13.8217 2.00003 20C2.00003 26.1783 4.83951 31.648 9.20003 35L28.8 35L30.8 35L30.8 35V35C35.1605 31.6479 38 26.1783 38 20C38 13.8217 35.1605 8.35208 30.8 5.00004V5ZM30.0969 7H9.90314C6.32922 9.99866 4.00003 14.6891 4.00003 20C4.00003 25.3109 6.32922 30.0013 9.90314 33H30.0969C33.6708 30.0013 36 25.3109 36 20C36 14.6891 33.6708 9.99866 30.0969 7ZM13 16H12V24H13V16ZM12 14H10V16V24V26H12H13H15V24V16V14H13H12ZM27 16H28V24H27V16ZM25 14H27H28H30V16V24V26H28H27H25V24V16V14Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomesticA);
export default __webpack_public_path__ + "static/media/DOMESTIC_A.0fdd171ff25c58ffadf3918e1039e90c.svg";
export { ForwardRef as ReactComponent };